<script setup>
  import { onMounted, inject, computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useEmployerStore } from '../stores/EmployerStore'
  import { useAuthStore } from '../stores/AuthStore'

  const customNavigation = inject('customNavigation')
  const employerStore = useEmployerStore()
  const authStore = useAuthStore()
  const { actualEmployer } = storeToRefs(employerStore)

  onMounted(() => {
    // console.log('bread')
    console.log(customNavigation.value, actualEmployer.value)
  })

  const breadCrumbs = computed(() => {
    return customNavigation.value.breadCrumbs
  })

  // The Home step honors the same declarative gate navigate() enforces on the Home route.
  // It is rendered here rather than declared in each route's breadCrumbs, so routes must
  // NOT list 'home' as an ancestor — that would render it twice.
  const canNavigateHome = computed(() => {
    const homeRoute = customNavigation.value.routes.Home
    return !homeRoute.permissions?.length || authStore.hasAnyPermission(homeRoute.permissions)
  })
</script>

<template>
  <div class="text-14 breadcrumbs fw-bold">
    <template v-if="canNavigateHome">
      <p @click="customNavigation.navigate({ newPage: customNavigation.routes.Home.name })">Home</p>
      <span>></span>
    </template>
    <template v-for="(step, index) in breadCrumbs" :key="step.location">
      <p
        :class="{ disabled: step.isDisabled }"
        @click="
          customNavigation.navigate({
            newPage: step.page,
            subPage: step.subPage,
            params: { planYearId: customNavigation.navigationParams.planYearId }
          })
        ">
        {{ step.title }}
      </p>
      <span v-if="index < breadCrumbs.length - 1">></span>
    </template>
  </div>
</template>

<style scoped>
  .breadcrumbs {
    font-weight: normal !important;
    margin-bottom: 5px !important;
  }

  .disabled {
    text-decoration: none;
    color: var(--bs-gray-600);
    cursor: text;
  }
</style>
